import { defineMessages } from 'react-intl';

export default defineMessages({
  button: {
    id: 'app.conversion.containers.GoToCartButton.button',
    defaultMessage: 'Ver mi pedido {value}',
  },
});
